export const AudioCodec = {
    EAC3: 'eac3',
    EC3: 'ec3',
};
